import $ from "jquery";
$(".js-searchbar-territory-toggle").on("click", (e) => {
  e.preventDefault();
  const toggleEl = $(e.currentTarget);
  const optionListEl = $(".js-searchbar-territory-list");

  optionListEl.toggleClass("open");
});

$(".js-searchbar-territory-option").on("click", (e) => {
  const optionEl = $(e.currentTarget);

  $(".js-searchbar-territory-list").removeClass("open");

  if (optionEl.hasClass("js-searchbar-members-option")) {
    $(".js-searchbar-territory-checkbox").prop("checked", true);
  } else {
    $(".js-searchbar-territory-checkbox").prop("checked", false);
  }
  $(".search-form").submit();
});
